/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/enterprise/authenticationMethod/AuthenticationMethodPanel.Props" />
import { IBasePanelContentProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/BasePanelContent.Props";
import { IDisableOAuthProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/DisableOAuth.props";
import { IShowPanelProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/ShowPanel.props";

export interface IAuthenticationMethodPanelProps extends IBasePanelContentProps, IShowPanelProps, IDisableOAuthProps {}
